export const GET_API_KEY_EVENTS_REQUEST = "GET_API_KEY_EVENTS_REQUEST";
export const GET_API_KEY_EVENTS_SUCCESS = "GET_API_KEY_EVENTS_SUCCESS";
export const GET_API_KEY_EVENTS_FAILURE = "GET_API_KEY_EVENTS_FAILURE";

export const getApiKeyEventsRequest = (apiKeyId) => ({
    type: GET_API_KEY_EVENTS_REQUEST,
    params: {
        apiKeyId
    }
})

export const getApiKeyEventsSuccess = (apiKeyEventResults) => ({
    type: GET_API_KEY_EVENTS_SUCCESS,
    payload: {
        apiKeyEventResults
    }
})

export const getApiKeyEventsFailure = (error) => ({
    type: GET_API_KEY_EVENTS_FAILURE,
    payload: {
        error
    }
})
